import React from 'react';
import Select from '@/components/ui/Select';
import FormItem from '@/components/ui/FormItem';
import { useEvaluator } from '@/components/views/Resolution886/components/Form/_hooks';
import type { FormItemProps } from '@/components/views/Resolution886/types';

export function EvaluatorFormItem({ fieldName = '', required = true }: Readonly<FormItemProps>): JSX.Element {
	const { isLoading, data, addItem, handleSearch, handleInputChange } = useEvaluator();

	return (
		<FormItem label="Evaluator" name={fieldName} requiredMessage="Please select an evaluator" required={required}>
			<Select.Multiple
				isAdd
				options={data}
				isSingle
				textButton="Add"
				addItem={addItem}
				loading={isLoading}
				onSearch={handleSearch}
				onInputChange={handleInputChange}
				placeholderInput="Please enter an evaluator"
				placeholder="Select an evaluator"
			/>
		</FormItem>
	);
}
